import { ExternalLoggingConstants } from "../ExternalLoggingConstants";

/**
 * represents base for all logg lists
 *
 * @author dkoehler
 */
export class AbstractLogObject {

    public logData: Map<string, string> = new Map();
    public isEssentialFilled: boolean = false;

    public get subErrorId(): string {
        return this.logData.get(ExternalLoggingConstants.PARAM_SUB_ERROR_ID);
    }

    public get data(): any {
        let obj: any = {};
        this.logData.forEach((value: string, key: string) => {
            obj[key] = value;
        });
        return obj;
    }
}
